import { render } from "./PaginationDots.vue?vue&type=template&id=28cc592b&scoped=true"
import script from "./PaginationDots.vue?vue&type=script&lang=js"
export * from "./PaginationDots.vue?vue&type=script&lang=js"

import "./PaginationDots.vue?vue&type=style&index=0&id=28cc592b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28cc592b"]])

export default __exports__